'use client'
import {
  useConfig_default
} from "./chunk-UDUUTZIS.mjs";

// src/hooks/useAuthConfig.ts
var useAuthConfig = () => {
  const { auth } = useConfig_default();
  return auth != null ? auth : {};
};

export {
  useAuthConfig
};
//# sourceMappingURL=chunk-B7T7AEYM.mjs.map